export const environment = {
  production: false,
  graphqlEndpoint: 'https://jssyetgpdrgwhlu72o2xlgnfsa.appsync-api.eu-central-1.amazonaws.com/graphql',
  region: 'eu-central-1',
  helpApiUrl: 'https://n0ajcbrdlc.execute-api.eu-central-1.amazonaws.com',
  amplifyConfiguration: {
    userPoolId: 'eu-central-1_Tb2yqG9Pi',
    userPoolClientId: '3drti164jholcmsvd83h0euou5',
    oauth: {
      domain: 'insolution-manager-auth-domain-acc.auth.eu-central-1.amazoncognito.com',
      scopes: ['email', 'openid', 'profile'],
      redirectSignIn: ['https://d1afo4uyly9q7k.cloudfront.net/'],
      redirectSignOut: ['https://d1afo4uyly9q7k.cloudfront.net/'],
      responseType: 'code',
    },
  },
  rumConfiguration: {
    appMonitorId: 'd9de2769-1e7a-4379-bfe6-4bf4061cfaa1',
    identityPoolId: 'eu-central-1:760fec9a-6161-41c6-a859-219967d5fcee',
    region: 'eu-central-1',
    appVersion: 'web',
    sampleRate: 1,
  },
};
